import './App.css';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Services from './components/Services';
import UpcomingFormations from './components/UpcomingFormations';
import FormationDetailPage from './pages/FormationDetailPage';
import LegalPage from './pages/LegalPage';
import Footer from './components/Footer';

function HomePage() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Features />
      <About />
      <Services />
      <UpcomingFormations />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/formations/:slug" element={<FormationDetailPage />} />
      <Route path="/mentions-legales" element={<LegalPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

export default App;
